import { sessionStorage,localStorage } from 'src/assets/js/storage';
import Cookies from 'js-cookie';

const mutations = {
  SET_USER (state, user) {
    state.user = user;
    localStorage.setItem('user', user);
  },
  SET_TOKEN (state, token) {
    state.token = token;
    //localStorage.setItem('token', token);
    Cookies.set("token", token)
  },
  SET_SITE_INFO (state, payload) {
    state.siteInfo = payload;
  },
};

export default mutations;




// WEBPACK FOOTER //
// ./src/store/mutations.js